import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-328d5007"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "suggestion" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Improved: ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Original:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reason:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Processing your transcription...", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.suggestion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_expansion_panels, {
            multiple: "",
            class: "suggestion__panels"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestion.suggestion_details, (detail, index) => {
                return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-5" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-account-voice")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(detail.topic) + " (" + _toDisplayString(detail.time_frame.start) + " - " + _toDisplayString(detail.time_frame.end) + ") ", 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_expansion_panel_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, {
                          dense: "",
                          lines: "two"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.suggestion_items, (item, idx) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, { key: idx }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { class: "mb-2" }, {
                                    default: _withCtx(() => [
                                      _hoisted_3,
                                      _createTextVNode(" " + _toDisplayString(item.improved_sentence), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_title, { class: "mb-2" }, {
                                    default: _withCtx(() => [
                                      _hoisted_4,
                                      _createTextVNode(" " + _toDisplayString(item.original_sentence), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_title, { class: "mb-2" }, {
                                    default: _withCtx(() => [
                                      _hoisted_5,
                                      _createTextVNode(" " + _toDisplayString(item.reasoning), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_divider)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          variant: "outlined",
          onClick: _ctx.executeMakeSuggestion
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Get Suggestions by Gemini ")
          ]),
          _: 1
        }, 8, ["onClick"])),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.processing,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.processing) = $event)),
      persistent: "",
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, { class: "text-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "64"
                }),
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.processingComplete,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.processingComplete) = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: _withCtx(() => [
                _createTextVNode("Processing Complete")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Your file has been processed successfully! ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.processingComplete = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OK")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.processingFailed,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.processingFailed) = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: _withCtx(() => [
                _createTextVNode("Proccesing Failed.")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Sorry, we couldn't process your request. "),
                _hoisted_7,
                _createTextVNode("Please try again later. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.processingFailed = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("OK")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}